export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">天美影视</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              天美影视电影大全，最新电影高清免费在线观看，不缓冲流畅追大片，免费在线看电影，高清电影大全在线看。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {['hero', 'index', 'ranking', 'carousel', 'updates', 'media'].map((id) => {
                const labels: Record<string, string> = {
                  hero: '首页',
                  index: '主题索引',
                  ranking: '热播排行',
                  carousel: '精选专题',
                  updates: '最新动态',
                  media: '精彩视频',
                };
                return (
                  <a
                    key={id}
                    href={`#${id}`}
                    onClick={(e) => { e.preventDefault(); scrollTo(id); }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {labels[id]}
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">合作品牌持续加入中，敬请期待。</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-200 mb-4">关注我们</h4>
            <div className="flex gap-3">
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 天美影视 版权所有 | 仅供学习交流使用
          </p>
          <div className="flex gap-4">
            <a href="#footer" onClick={(e) => e.preventDefault()} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#footer" onClick={(e) => e.preventDefault()} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#footer" onClick={(e) => e.preventDefault()} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}